import Guardian from "./Guardian";
import common from "../../common";

export default class GuardianWizard extends Guardian {
    constructor(golden = false) {
        super("guardian_wizard", Guardian.TYPE_WIZARD, golden);

        this.setIdleAnims(["idle1_wizard"]);
        this.setAttackAnims(["attack_wizard1"]);
        this.setDamageAnims(["damage_wizard1"]);
        this.setDefeatAnims(["defeat_wizard1"]);
        this.setVictoryAnims(["victory_wizard1"]);
        this.setWeaponRevealAnims(["weapon_reveal_wizard1"]);

        this._attackSoundName = "sfx_guardian_spell_attack_00";
    }
}